import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  REQUEST_GET_PROVIDER_LIST,
  SUCCESS_GET_PROVIDER_LIST,
  FAILURE_GET_PROVIDER_LIST,
  LOADING_GET_PROVIDER_LIST,
} = documentationActions;

function* getAlTherapistList(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_PROVIDER_LIST });
    const response = yield call(templateService.getAllTherapist, action.discipline, action.role,action?.therapistId);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_PROVIDER_LIST, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_PROVIDER_LIST, payload: error });
  }
}

function* getAlTherapistListSaga() {
  yield takeEvery(REQUEST_GET_PROVIDER_LIST, getAlTherapistList);
}

export default getAlTherapistListSaga;
